const LEGACY_GRAPHQL_SUFFIX = /\/graphql$/;

const API_BASE_URL = ((import.meta.env.VITE_API_URL as string | undefined) ?? '/api').replace(
  LEGACY_GRAPHQL_SUFFIX,
  '',
);

export const STAFF_GRAPHQL_URL = `${API_BASE_URL}/staff/graphql`;

export function buildApiUrl(path: string): string {
  return `${API_BASE_URL}${path}`;
}
